<div class="main-content">
  <div class="header-actions">
    <h4 class="card-title">Orders List</h4>
    <span class="header-buttons">
      <!-- Labels for every Singapore and US order on this page. -->
      <button
        mat-stroked-button
        [disabled]="!pageSgOrderIds().length"
        (click)="printLabels(pageSgOrderIds())"
      >
        <mat-icon>print</mat-icon>
        Print labels ({{ pageSgOrderIds().length }})
      </button>
      <fh-refresh-button [onRefresh]="refreshOrders" />
    </span>
  </div>

  <fh-filter-bar [showResetButton]="false">
    <!-- Country filter -->
    <fh-form-autocomplete
      [options]="countryOptions()"
      label="Country"
      placeholder="Select country..."
      appearance="outline"
      [formControl]="countryFilterFormControl"
      (selectionChange)="onCountryChange($any($event))"
    />

    <!-- Search + Reset slot -->
    <div class="search-reset-slot">
      <mat-form-field appearance="outline" class="search-field">
        <mat-label>Search Order ID</mat-label>
        <input
          matInput
          [formControl]="searchControl"
          (keyup.enter)="onSearch()"
          placeholder="Type to search..."
        />
        <button matSuffix mat-icon-button (click)="onSearch()">
          <mat-icon>search</mat-icon>
        </button>
        @if (searchTerm()) {
          <button matSuffix mat-icon-button (click)="searchControl.setValue(''); onSearch()">
            <mat-icon>clear</mat-icon>
          </button>
        }
      </mat-form-field>

      <button mat-stroked-button (click)="onResetFilters()" class="reset-btn">
        <mat-icon>refresh</mat-icon>
        Reset Filters
      </button>
    </div>
  </fh-filter-bar>

  <fh-data-table
    [config]="tableConfig()"
    [sortProp]="sortProp()"
    [sortDir]="sortDir()"
    [pageIndex]="pageIndex()"
    [pageSize]="pageSize()"
    [actions]="tableActions()"
    (sortChange)="onSortChange($event)"
    (pageChange)="onPageChange($event)"
  />
</div>
